import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { ISelectedItemType } from '../../types';
import styles from './styles.module.scss';

interface PopupProps {
  open: boolean;
  onClose: () => void;
  item: ISelectedItemType;
  isWideImage?: boolean;
}

const Popup: React.FC<PopupProps> = ({
  isWideImage, open, onClose, item,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (open && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [open]);

  if (!open) return null;

  const modalContent = ( // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div className={styles.popupOverlay} onClick={onClose}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div ref={ref} className={styles.popupModal} onClick={(e) => e.stopPropagation()}>
        <img
          src={item.image}
          alt={item.title}
          className={
            classNames(styles.popupImage, {
              [styles.wideImage]: isWideImage,
            })
          }
        />
        {item.category && (
          <>
            <div className={styles.popupCategoryLabel}>Category</div>
            <div className={styles.popupCategory}>{item.category}</div>
          </>
        )}
        <div className={styles.popupTitle}>{item.title}</div>
        <div className={styles.popupDescription}>{item.description}</div>
        <button className={styles.popupClose} onClick={onClose} type="button">Close</button>
      </div>
    </div>
  );

  const portalRoot = document.getElementById('modal-root');
  return portalRoot ? ReactDOM.createPortal(modalContent, portalRoot) : null;
};

export default Popup;
